/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// @ts-nocheck
import { makeRequest } from "@/utils/axiosInterceptor";

async function getApiData() {
    try {
        const accessRoute = '/apis'
        const { data: apiData } = await makeRequest("GET", accessRoute, "");
        return apiData.reverse();
    } catch (error) {
        console.error("Error fetching instances:", error);
        return [];
    }
}
export default getApiData;
